// src/components/list/CorrelationConsumptionItem.tsx

import {
  Avatar,
  Checkbox,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Tooltip,
} from '@mui/material'
import { MouseEvent } from 'react'

import {
  SensorId,
  SensorName,
  SensorStatus,
  TypeInFolder,
} from '@/types/domain'

import { SensorIcon } from '../../api'
import {
  OperatorData,
  useOperator,
  useSensorName,
  useSensorStatus,
  useTypeInFolder,
} from '../../hooks'

type CorrelationConsumptionItemProps = {
  id: SensorId
  onClick?: (_: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => void
  selected: boolean
}

export const CorrelationConsumptionItem = ({
  id,
  onClick,
  selected,
}: CorrelationConsumptionItemProps) => {
  const name: SensorName = useSensorName(id)
  const opData: OperatorData = useOperator()
  const status: SensorStatus = useSensorStatus(id)
  const tif: TypeInFolder = useTypeInFolder(id)

  const src: string = SensorIcon(tif, status)
  const title: string = opData?.isAdmin ? `Sensor ID: ${id}` : ''

  return (
    <ListItem sx={{ p: 0, width: 1 }}>
      <ListItemButton onClick={onClick} selected={selected}>
        <ListItemAvatar>
          <Tooltip title={title}>
            <Avatar src={src} />
          </Tooltip>
        </ListItemAvatar>

        <ListItemText primary={name} />

        <Checkbox color={'primary'} checked={selected} />
      </ListItemButton>
    </ListItem>
  )
}
